import { useState, useEffect } from "react";
import { Icons } from "../../components/common/Icons";
import api from "../../services/api";
import EmpModal from "./EmpModal";
import { AvatarDisplay } from "../../components/common/AvatarUpload";import "../../assets/styles/Employee/EmpPeoplePage.css";

function EmpPeoplePage() {
  const [people, setPeople] = useState([]);
  const [search, setSearch] = useState("");
  const [roleFilter, setRoleFilter] = useState("all");
  const [selectedUser, setSelectedUser] = useState(null);
  const [userProfile, setUserProfile] = useState(null);

  useEffect(() => {
    api.getPeopleDirectory().then((data) => {
      if (Array.isArray(data)) setPeople(data);
    }).catch(() => {});
  }, []);

  const filtered = people.filter((p) => {
    const q = search.toLowerCase();
    const matchSearch = !q || p.name?.toLowerCase().includes(q) || p.emp_id?.toLowerCase().includes(q) || p.department?.toLowerCase().includes(q);
    const matchRole = roleFilter === "all" || p.role === roleFilter;
    return matchSearch && matchRole;
  });

  const viewProfile = async (user) => {
    setSelectedUser(user);
    try {
      const data = await api.getProfileById(user.emp_id);
      setUserProfile(data.profile || data);
    } catch {
      setUserProfile(user);
    }
  };

  const roles = [...new Set(people.map((p) => p.role))].filter(Boolean);
  const roleBadge = { hr: '#8b5cf6', pm: '#3b82f6', employee: '#2563eb', intern: '#f59e0b', itadmin: '#ef4444', superadmin: '#1e293b' };

  return (
    <div>
      <div className="emppeoplepage-inline-1">
        <div className="emppeoplepage-inline-2">
          <Icons.Search className="emppeoplepage-inline-3" />
          <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search by name, ID, or department..." className="form-input emppeoplepage-inline-4" />
        </div>
        <select value={roleFilter} onChange={(e) => setRoleFilter(e.target.value)} className="form-input emppeoplepage-inline-5">
          <option value="all">All Roles</option>
          {roles.map((r) => <option key={r} value={r}>{r.charAt(0).toUpperCase() + r.slice(1)}</option>)}
        </select>
      </div>
      <div className="emppeoplepage-inline-6">{filtered.length} people found</div>
      <div className="emppeoplepage-inline-7">
        {filtered.map((p) =>
        <div key={p.id} className="card animate-in emppeoplepage-inline-8" onClick={() => viewProfile(p)}>
            <div className="card-body emppeoplepage-inline-9">
              <AvatarDisplay src={p.avatar} name={p.name} size={44} />
              <div className="emppeoplepage-inline-10">
                <div className="emppeoplepage-inline-11">{p.name}</div>
                <div className="emppeoplepage-inline-12">{p.designation || p.role} · {p.department || "—"}</div>
                <div className="emppeoplepage-inline-13">{p.emp_id}</div>
              </div>
              <span style={{ "--emppeoplepage-1-background": (roleBadge[p.role] || '#94a3b8') + '18', "--emppeoplepage-1-color": roleBadge[p.role] || '#94a3b8' }} className="emppeoplepage-dyn-1">{p.role}</span>
            </div>
          </div>
        )}
      </div>
      {filtered.length === 0 && <div className="card emppeoplepage-inline-14"><div className="emppeoplepage-inline-15">👥</div><div className="emppeoplepage-inline-16">No people found</div><div className="emppeoplepage-inline-17">Try adjusting your search or filters</div></div>}

      {selectedUser && <EmpModal title={selectedUser.name} onClose={() => {setSelectedUser(null);setUserProfile(null);}}>
        <div className="emppeoplepage-inline-18">
          <AvatarDisplay src={selectedUser.avatar} name={selectedUser.name} size={56} />
          <div>
            <div className="emppeoplepage-inline-19">{selectedUser.name}</div>
            <div className="emppeoplepage-inline-20">{userProfile?.designation || selectedUser.designation || selectedUser.role}</div>
            <div className="emppeoplepage-inline-21">{selectedUser.emp_id}</div>
          </div>
        </div>
        <div className="emppeoplepage-inline-22">
          {[
          ["Email", userProfile?.email || selectedUser.email],
          ["Phone", userProfile?.phone || selectedUser.phone],
          ["Department", userProfile?.department || selectedUser.department],
          ["Team", userProfile?.team],
          ["Manager", userProfile?.manager || userProfile?.manager_name || selectedUser.manager_name],
          ["Location", userProfile?.location || selectedUser.location],
          ["Joining Date", userProfile?.joining_date || selectedUser.joining_date],
          ["Status", selectedUser.status]].
          filter(([, v]) => v).map(([label, value]) =>
          <div key={label} className="emppeoplepage-inline-23">
              <div className="emppeoplepage-inline-24">{label}</div>
              <div className="emppeoplepage-inline-25">{String(value)}</div>
            </div>
          )}
        </div>
      </EmpModal>}
    </div>);

}

export default EmpPeoplePage;